import { UserModel } from "../models/UserModel";
import API, { client } from "./API";

const UserService = {
  async getAllUsers() {
    const response = await API().get("User", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getParticularUser(user_id: number) {
    const response = await API().get("User");
    return response.data.filter(
      (cur_user: UserModel) => cur_user.userId === user_id
    )[0];
  },
  async validateUserCredentials(user_email: string, user_password: string) {
    const userObject = {
      userEmail: user_email,
      userPassword: user_password,
    };
    const response = await API().post(
      "User/ValidateUserCredentials",
      JSON.stringify(userObject),
      {
        method: "POST",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data[0];
  },
  async createUser(data: UserModel, id?: number) {
    try {
      const response = await client({
        method: id ? "put" : "post",
        url: id ? `User/${id}` : "User",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async setIsAdmin(id: number, status: boolean) {
    try {
      const response = await client({
        url: `User/SetIsAdmin/${id}/${status ? "yes" : "no"}`,
        method: "post",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async setIsImportantEmailReceiver(id: number, status: boolean) {
    try {
      const response = await client({
        url: `User/SetIsImportantEmailReceiver/${id}/${status ? "yes" : "no"}`,
        method: "post",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default UserService;
